import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import RealEstateOSPage from './pages/RealEstateOSPage';
import AnalyzePage from './pages/AnalyzePage';
import LoginPage from './pages/admin/LoginPage';
import DashboardLayout from './pages/admin/DashboardLayout';
import DashboardHome from './pages/admin/DashboardHome';
import MessagesPage from './pages/admin/MessagesPage';
import SectionsPage from './pages/admin/SectionsPage';
import AnalysesPage from './pages/admin/AnalysesPage';
import ToolSettingsPage from './pages/admin/ToolSettingsPage';
import SettingsPage from './pages/admin/SettingsPage';
import ProductsAdminPage from './pages/admin/ProductsAdminPage';
import QuoteRequestsPage from './pages/admin/QuoteRequestsPage';
import ArticlesAdminPage from './pages/admin/ArticlesAdminPage';
import WhatsAppButton from './components/WhatsAppButton';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LanguageProvider><LandingPage /></LanguageProvider>} />
      <Route path="/products" element={<LanguageProvider><ProductsPage /></LanguageProvider>} />
      <Route path="/products/nexa-real-estate-os" element={<LanguageProvider><RealEstateOSPage /></LanguageProvider>} />
      <Route path="/products/:slug" element={<LanguageProvider><ProductDetailPage /></LanguageProvider>} />
      <Route path="/blog" element={<Navigate to="/" replace />} />
      <Route path="/blog/*" element={<Navigate to="/" replace />} />
      <Route path="/analyze" element={<LanguageProvider><AnalyzePage /></LanguageProvider>} />
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin" element={<DashboardLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="sections" element={<SectionsPage />} />
        <Route path="products-manage" element={<ProductsAdminPage />} />
        <Route path="articles" element={<ArticlesAdminPage />} />
        <Route path="quote-requests" element={<QuoteRequestsPage />} />
        <Route path="analyses" element={<AnalysesPage />} />
        <Route path="tool-settings" element={<ToolSettingsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <WhatsAppButton />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
